import axios from '@/plugins/axios';

export default {
    getUsers(resourcesPerPage, search, role) {
        return axios.get("/user?resourcesPerPage=" + resourcesPerPage + "&search=" + search + "&role=" + role);
    },
    postUser(payload) {
        return axios.post('/create', payload);
    }
}